module.exports = __webpack_public_path__ + "static/media/noli-logo.d768d3f3.png";